import React from "react";
import "./AddAutovehicles.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";

const ReviewForm = ({ data, setData, errors = {}, editMode }) => {

    // actualizează câmpurile de tip dată
    const updateDate = (field, date) => {
        if (!editMode) return;
        setData((prev) => ({
            ...prev,
            [field]: date ? format(date, "yyyy-MM-dd") : ""
        }));
    };

    // actualizează câmpurile simple
    const updateField = (field, value) => {
        if (!editMode) return;
        setData((prev) => ({
            ...prev,
            [field]: value
        }));
    };

    return (
        <div className="review-card">
            <h3>Review</h3>

            {/* LAST REVIEW */}
            <h4>Last review</h4>
            <div className="review-row">

                {/* REVIEW DATE */}
                <div className="field">
                    <label>Review date</label>

                    <div className="datepicker-container">

                        <DatePicker
                            id="review-date"
                            disabled={!editMode}
                            selected={data.review_data ? new Date(data.review_data) : null}
                            onChange={(date) => updateDate("review_data", date)}
                            dateFormat="dd.MM.yyyy"
                            placeholderText="dd.mm.yyyy"
                            className="datepicker-input-with-icon"
                            calendarClassName="custom-calendar"
                            autoComplete="off"
                        />

                        {editMode && (
                            <span
                                className="calendar-icon-inside"
                                onClick={() => document.querySelector("#review-date")?.focus()}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18"
                                    viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                                    <line x1="16" y1="2" x2="16" y2="6" />
                                    <line x1="8" y1="2" x2="8" y2="6" />
                                    <line x1="3" y1="10" x2="21" y2="10" />
                                </svg>
                            </span>
                        )}
                    </div>

                    {errors?.review_data && (
                        <span className="field-error">{errors.review_data}</span>
                    )}
                </div>

                {/* KM */}
                <div className="review-field">
                    <label>Km</label>
                    <input
                        type="number"
                        disabled={!editMode}
                        value={data.review_km}
                        onChange={(e) => updateField("review_km", e.target.value)}
                        placeholder="Ex: 120000"
                    />
                </div>

                {/* INTERVAL */}
                <div className="review-field">
                    <label>Interval</label>
                    <input
                        type="number"
                        disabled={!editMode}
                        value={data.review_interval}
                        onChange={(e) => updateField("review_interval", e.target.value)}
                        placeholder="Ex: 10000"
                    />
                </div>

            </div>

            {/* NEXT REVIEW */}
            <h4>Next review</h4>
            <div className="review-row">

                {/* ESTIMATED REVIEW DATE */}
                <div className="field">
                    <label>Estimated date</label>

                    <div className="datepicker-container">

                        <DatePicker
                            id="review-estimate"
                            disabled={!editMode}
                            selected={data.estimate_date_review ? new Date(data.estimate_date_review) : null}
                            onChange={(date) => updateDate("estimate_date_review", date)}
                            dateFormat="dd.MM.yyyy"
                            placeholderText="dd.mm.yyyy"
                            className="datepicker-input-with-icon"
                            calendarClassName="custom-calendar"
                            autoComplete="off"
                        />

                        {editMode && (
                            <span
                                className="calendar-icon-inside"
                                onClick={() => document.querySelector("#review-estimate")?.focus()}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18"
                                    viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                                    <line x1="16" y1="2" x2="16" y2="6" />
                                    <line x1="8" y1="2" x2="8" y2="6" />
                                    <line x1="3" y1="10" x2="21" y2="10" />
                                </svg>
                            </span>
                        )}
                    </div>

                    {errors?.estimate_date_review && (
                        <span className="field-error">{errors.estimate_date_review}</span>
                    )}
                </div>

                {/* NEXT KM */}
                <div className="review-field">
                    <label>Km</label>
                    <input
                        type="number"
                        disabled={!editMode}
                        value={data.estimate_km_review}
                        onChange={(e) => updateField("estimate_km_review", e.target.value)}
                        placeholder="Ex: 180000"
                    />
                </div>

            </div>
        </div>
    );
};

export default ReviewForm;